import { AutomationLogsProvider } from '../../context/automationLogsContext'
import { AutomationLogsContent } from './ui/AutomationLogsContent/AutomationLogsContent'

export const AutomationLogs = () => (
  <AutomationLogsProvider>
    <AutomationLogsContent />
  </AutomationLogsProvider>
)
